export default [
  { to: 'medicinskaRiktlinjer', title: 'Behandlingsriktlinjer' },
  { to: 'rutiner', title: 'Rutiner' },
  { to: 'info', title: 'Info' },
  { to: 'changelog', title: 'Ändringslogg' },
];
